<script lang="ts">
  import { CommonTexts } from '../services/CommonTexts';
  import dwcLogo from '../../assets/dwc.png';
</script>

<div class="LayoutLogo">
  <figure>
    <picture>
      <img alt={CommonTexts.LogoAlt} src={dwcLogo} />
    </picture>
  </figure>
</div>

<style lang="scss">
  .LayoutLogo {
    picture {
      max-width: 15rem;
      margin: 0 auto;
    }
  }
</style>
